import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  FormControl,
  NativeSelect,
  InputBase,
  Button,
} from "@material-ui/core";
import TextareaAutosize from '@mui/base/TextareaAutosize';
import { useStylesApp } from "hooks/useStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useSnackbar } from "notistack";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { tipoContribuyente, unidadPeso } from "./typeVoucher";
import { validationLogisticOrderInvoice } from "./Validations/validationsForms";

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: "0.5%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    color: palette.primary.menuHeader,
  },
  accordionSumary: {
    backgroundColor: palette.primary.light,
  },
  margin: {
    margin: theme.spacing(0),
    width: "100%",
    marginBottom: "1%",
  },
}));

export default function LogisticsInformationInvoice({ logisticInfoInvoice, setLogisticInfoInvoice }) {
  const classes = useStyles();
  const classesGlobal = useStylesGlobal();
  const classesApp = useStylesApp();
  const { enqueueSnackbar } = useSnackbar();
  const [rucAutorizado, setRucAutorizado] = useState({
    dv: "",
    ruc: "",
    tipoRuc: "",
  });
  const [errors, setErrors] = useState({});
  const [informacionLogistica, setInformacionLogistica] = useState({});

  const handleChangeRuc = (event) => {
    setRucAutorizado({
      ...rucAutorizado,
      [event.target.name]: event.target.value,
    });
  };

  const handleChange = (event) => {
    setInformacionLogistica({
      ...informacionLogistica,
      [event.target.name]: event.target.value,
    });
  };

  const validateLogisticInformation = (data, rucAuthorized) => {
    let newErrors = validationLogisticOrderInvoice.onSubmit({
      nombreTransportista: data.nombreTransportista,
      tipoRuc: rucAuthorized.tipoRuc,
      ruc: rucAuthorized.ruc,
      dv: rucAuthorized.dv,
      nrovolumenes: data.nrovolumenes,
      pesoCarga: data.pesoCarga,
      licenciaVehiculo: data.licenciaVehiculo,
      informacionInteres: data.informacionInteres,
    });
    if (Object.entries(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    } else {
      return true;
    }
  };

  const handleClickAdd = () => {
    if (validateLogisticInformation(informacionLogistica, rucAutorizado)) {
      setLogisticInfoInvoice({ ...informacionLogistica, rucAutorizado: rucAutorizado, });
      enqueueSnackbar(`Información logística agregada al comprobante`, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        autoHideDuration: 4000,
      });
      setErrors({});
    } else {
      setLogisticInfoInvoice({});
    }
  }

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <label className={classesGlobal.titleCard}>
            Información de Logística:{" "}
          </label>
          <label className={classesGlobal.click}>
            <label> </label> (Clic Aquí)
          </label>
        </AccordionSummary>
        <AccordionDetails>
          <from style={{ width: "100%" }}>
            <Grid
              container
              xs={12}
              md={12}
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={12} md={2}>
                <label>Número de volúmenes:</label>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="nrovolumenes"
                  value={informacionLogistica.nrovolumenes}
                  onChange={handleChange}
                />
                {errors.nrovolumenes ? (
                  <p className={classesApp.errorLetters}>
                    {errors.nrovolumenes}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Peso total de la carga:</label>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="pesoCarga"
                  value={informacionLogistica.pesoCarga}
                  onChange={handleChange}
                />
                {errors.pesoCarga ? (
                  <p className={classesApp.errorLetters}>
                    {errors.pesoCarga}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Unidad del peso total:</label>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                <FormControl className={classesGlobal.select}>
                  <NativeSelect
                    value={informacionLogistica.unidadPeso}
                    name="unidadPeso"
                    onChange={handleChange}
                    input={<BootstrapInput />}
                  >
                    <option aria-label="None" value="">
                      --Seleccione--
                    </option>
                    {unidadPeso.map((element) => (
                      <option key={element.CODIGO} value={element.CODIGO}>
                        {element.NOMBRE}
                      </option>
                    ))}
                  </NativeSelect>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Licencia del vehículo de carga:</label>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="licenciaVehiculo"
                  value={informacionLogistica.licenciaVehiculo}
                  onChange={handleChange}
                />
                {errors.licenciaVehiculo ? (
                  <p className={classesApp.errorLetters}>
                    {errors.licenciaVehiculo}
                  </p>
                ) : null}
              </Grid>
              <title>Información del transportista</title>
              <Grid item xs={12} md={2}>
                <label>Nombre:</label> <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="nombreTransportista"
                  value={informacionLogistica.nombreTransportista}
                  onChange={handleChange}
                />
                {errors.nombreTransportista ? (
                  <p className={classesApp.errorLetters}>
                    {errors.nombreTransportista}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Tipo de contribuyente:</label> <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                <FormControl className={classesGlobal.select}>
                  <NativeSelect
                    value={rucAutorizado.tipoRuc}
                    name="tipoRuc"
                    onChange={handleChangeRuc}
                    input={<BootstrapInput />}
                  >
                    <option aria-label="None" value="">
                      --Seleccione--
                    </option>
                    {tipoContribuyente.map((element) => (
                      <option key={element.CODIGO} value={element.CODIGO}>
                        {element.NOMBRE}
                      </option>
                    ))}
                  </NativeSelect>
                </FormControl>
                {errors.tipoRuc ? (
                  <p className={classesApp.errorLetters}>
                    {errors.tipoRuc}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>RUC:</label> <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="ruc"
                  value={rucAutorizado.ruc}
                  onChange={handleChangeRuc}
                />
                {errors.ruc ? (
                  <p className={classesApp.errorLetters}>
                    {errors.ruc}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Dígito verificador:</label> <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="dv"
                  value={rucAutorizado.dv}
                  onChange={handleChangeRuc}
                />
                {errors.dv ? (
                  <p className={classesApp.errorLetters}>
                    {errors.dv}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Información adicional:</label>
              </Grid>
              <Grid item xs={12} md={10}>
                <TextareaAutosize
                  minRows={3}
                  type="string"
                  className="form-control"
                  name="informacionInteres"
                  value={informacionLogistica.informacionInteres}
                  onChange={handleChange}
                />
                {errors.informacionInteres ? (
                  <p className={classesApp.errorLetters}>
                    {errors.informacionInteres}
                  </p>
                ) : null}
              </Grid>
            </Grid>
          </from>
          <Button variant="outlined" color="primary" onClick={handleClickAdd}>
            Agregar información logística
          </Button>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
